import {
  faArrowsRotate,
  faWifi,
  faWifiSlash,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useWebSocketContext } from '@hypeit-gmbh/hypeit-ui-core';
import { ActionIcon, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const WebSocketConnectionIndicator: React.FC = () => {
  const { t } = useTranslation();
  const { isConnected, isReconnecting, connect } = useWebSocketContext();
  const canReconnect = !isConnected && !isReconnecting;

  const statusLabel = isReconnecting
    ? t('HEADER.WEBSOCKET.RECONNECTING')
    : isConnected
      ? t('HEADER.WEBSOCKET.CONNECTED')
      : t('HEADER.WEBSOCKET.DISCONNECTED');
  const label = canReconnect
    ? `${statusLabel}. ${t('HEADER.WEBSOCKET.RECONNECT')}`
    : statusLabel;
  const icon = isReconnecting
    ? faArrowsRotate
    : isConnected
      ? faWifi
      : faWifiSlash;

  return (
    <Tooltip label={label}>
      <ActionIcon
        variant="subtle"
        color={isReconnecting ? 'yellow' : isConnected ? 'green' : 'red'}
        onClick={canReconnect ? connect : undefined}
        aria-label={label}
      >
        <FontAwesomeIcon icon={icon} spin={isReconnecting} />
      </ActionIcon>
    </Tooltip>
  );
};
